import Circles from './Circles';
import Lines from './Lines';
import Paths from './Paths';

export default {
  Circles: Circles,
  Lines: Lines,
  Paths: Paths
};